/* RYS-FLO-RELAY v1 — Shopflo-first checkout relay (10-Aug-2026)
   Why: Shopflo's bundle loads async (theme.liquid). If a customer taps
   CHECKOUT before it resolves, the fallback chain drops them on NATIVE
   Shopify checkout with no indication — which is how orders split across
   source_name "web" and "Created by Shopflo" on 6-7 Aug, and why a test
   session landed on Shopify's own checkout while Flo Checkout was live.
   This holds the click until Shopflo is ready instead of giving up. */
(function () {
  'use strict';
  if (window.__rysFloRelay) return; window.__rysFloRelay = true;

  var MAX_WAIT = 4000, POLL = 100;
  var SELECTOR = '#rys-co, [name="checkout"], .rys-checkout, [data-rys-checkout]';

  function floReady() { return typeof window.handleFloCheckoutBtn === 'function'; }
  function fire() {
    try { window.handleFloCheckoutBtn(); return true; }
    catch (e) { console.warn('[rys-flo] trigger threw:', e); return false; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(SELECTOR);
    if (!btn) return;

    if (floReady()) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (!fire()) window.location.href = '/checkout';
      return;
    }

    /* Bundle not up yet — hold the click rather than falling through. */
    e.preventDefault(); e.stopImmediatePropagation();
    var original = btn.textContent, waited = 0;
    try { btn.setAttribute('aria-busy', 'true'); } catch (x) {}
    var timer = setInterval(function () {
      waited += POLL;
      if (floReady()) {
        clearInterval(timer);
        try { btn.removeAttribute('aria-busy'); btn.textContent = original; } catch (x) {}
        if (!fire()) window.location.href = '/checkout';
      } else if (waited >= MAX_WAIT) {
        clearInterval(timer);
        try { btn.removeAttribute('aria-busy'); btn.textContent = original; } catch (x) {}
        console.warn('[rys-flo] Shopflo never loaded in ' + MAX_WAIT + 'ms — native checkout');
        window.location.href = '/checkout';
      }
    }, POLL);
  }, true);
})();
